import { useMutation, useQuery } from "@tanstack/react-query";
import {
  getMaintenanceSetting,
  getPagesList,
  updateMaintenanceSetting,
} from "api/siteSettings/maintenance";
import { ApiResponseType, NotificationType } from "enums";
import { printError, useSearch, useUtilities } from "helpers";
import { t } from "i18next";
import { useEffect } from "react";
import { setMaintenanceSetting } from "redux/reducers/siteSettings/maintenance";

export function useGetMaintenanceSetting() {
  const { web = null } = useSearch();
  return useQuery(["maintenance", web], () => getMaintenanceSetting(web));
}

export function useMaintenance() {
  const { web = null } = useSearch();
  const { data, isLoading, error } = useGetMaintenanceSetting();
  const {
    dispatch,
    maintenance: { maintenance, loaded, website_id },
  } = useUtilities();

  useEffect(() => {
    if (data && (!loaded || website_id !== web)) {
      dispatch(
        setMaintenanceSetting({
          maintenance: data.data[0],
          website_id: web,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, loaded, web, website_id]);

  return {
    data: maintenance,
    isLoading: isLoading || !loaded,
    error,
  };
}

export function usePagesList() {
  const { web } = useSearch();
  return useQuery(["pages", web], () => getPagesList(web), {
    enabled: Boolean(web),
  });
}

export function useUpdateMaintenanceSetting() {
  const { notification, dispatch } = useUtilities();
  const { web = null } = useSearch();

  return useMutation(updateMaintenanceSetting, {
    onSuccess: (data) => {
      if (data.status_code === ApiResponseType.SUCCESS) {
        dispatch(
          setMaintenanceSetting({
            maintenance: data.data,
            website_id: web,
          })
        );
        notification({
          type: NotificationType.SUCCESS,
          message: t("siteSetting.maintenance.api.notification.updated"),
        });
      } else {
        notification({
          type: NotificationType.ERROR,
          message: printError(data.message),
        });
      }
    },
    onError: (error) => {
      notification({
        type: NotificationType.ERROR,
        message: printError(error.message),
      });
    },
  });
}
